const PERSON_CONTEXT_KEYS = new Set([
  'user', 'users', 'employee', 'employees', 'member', 'members', 'sender', 'author',
  'creator', 'actor', 'assignee', 'owner', 'manager', 'reviewer', 'reporter',
  'reportedUser', 'targetEmployee', 'createdBy', 'updatedBy', 'approvedBy', 'postedBy',
  'reversedBy', 'from', 'participants'
]);

const PERSON_NAME_FIELD = /^(?:employee|user|person|sender|author|creator|actor|assignee|owner|manager|reviewer|reporter|createdBy|updatedBy|approvedBy|postedBy|reversedBy|directorApprovedBy|accountantApprovedBy)Name$/iu;

export function personDisplayName(value) {
  return String(value || '')
    .trim()
    .split(/\s+/u)
    .filter(Boolean)
    .slice(0, 2)
    .join(' ');
}

function looksLikePerson(value, contextKey) {
  if (PERSON_CONTEXT_KEYS.has(contextKey)) return true;
  if (!value || typeof value !== 'object' || Array.isArray(value)) return false;
  return Object.hasOwn(value, 'name') && [
    'avatarUrl', 'login', 'registrationStatus', 'positionId', 'departmentId',
    'restaurantIds', 'additionalPositionIds', 'isPlatformAdmin', 'lastSeen'
  ].some((key) => Object.hasOwn(value, key));
}

export function normalizePersonDisplayNames(value, contextKey = '', seen = new WeakSet()) {
  if (!value || typeof value !== 'object') return value;
  if (seen.has(value)) return value;
  seen.add(value);
  if (Array.isArray(value)) {
    for (const item of value) normalizePersonDisplayNames(item, contextKey, seen);
    return value;
  }

  const person = looksLikePerson(value, contextKey);
  for (const [key, item] of Object.entries(value)) {
    if (typeof item === 'string' && ((key === 'name' && person) || PERSON_NAME_FIELD.test(key))) {
      value[key] = personDisplayName(item);
    } else {
      normalizePersonDisplayNames(item, key, seen);
    }
  }
  return value;
}
